import type { DateOrTimestamp } from './common';

export const NotificationChannel = {
  APNS: 'apns',
  VOIP: 'apns_voip',
  GCM: 'gcm',
  WEB: 'web',
} as const;
export type NotificationChannel = (typeof NotificationChannel)[keyof typeof NotificationChannel];

export const DevicePlatform = {
  IOS: 'ios',
  ANDROID: 'android',
  WEB: 'web',
} as const;
export type DevicePlatform = (typeof DevicePlatform)[keyof typeof DevicePlatform];

export const PushEnvironment = {
  DEV: 'development',
  PROD: 'production',
} as const;
export type PushEnvironment = (typeof PushEnvironment)[keyof typeof PushEnvironment];

export namespace ConnectyCubePushNotifications {
  export type Subscription = {
    subscription: {
      id: number | string;
      notification_channel: {
        name: NotificationChannel | string;
      };
      device: {
        udid: string;
        platform: {
          name: DevicePlatform | string;
        };
      };
    };
  };
  export type Event = {
    event: {
      id: number;
      event_type: string | null;
      message: string | null;
      date: DateOrTimestamp;
      period: DateOrTimestamp;
      name: string | null;
      occured_count?: number;
      created_at?: DateOrTimestamp;
      updated_at?: DateOrTimestamp;
      end_date?: DateOrTimestamp;
      active?: boolean | null;
      application_id: number | null;
      user_id: number | null;
      kind: string | null;
      environment: PushEnvironment | null;
      tag_query?: string;
      notification_channel?: {
        name?: NotificationChannel | null;
      };
    };
  };
  export type PushTokenBaseParams = {
    environment: PushEnvironment | string;
  };
  export type PushTokenMobileParams = PushTokenBaseParams & {
    client_identification_sequence: string;
    bundle_identifier?: string;
  };
  export type PushTokenWebParams = PushTokenBaseParams & {
    web_endpoint: string;
    web_auth: string;
    web_p256dh: string;
  };
  // Request parameters type
  export type SubscriptionsCreateParams = {
    notification_channels: NotificationChannel | string;
    push_token: PushTokenMobileParams | PushTokenWebParams;
    device: {
      platform: DevicePlatform | string;
      udid: string;
    };
  };
  export type EventsCreateParams = {
    notification_type: 'push' | string;
    push_type: NotificationChannel | string;
    environment: PushEnvironment | string;
    event_type?: 'one_shot' | string;
    message?: string | null;
    user?: {
      ids: string | number[];
      tags?: {
        any?: string;
        all?: string;
        exclude?: string;
      };
    };
    external_user?: { ids: string | number[] };
  };
}
